import { Button } from "primereact/button";
import { Dialog } from "primereact/dialog";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { Link, Route, Routes, useLocation } from "react-router-dom";
import { iphone } from "../../types/Regex";
import NotFound from "../404/NotFound";
import AdminLayout from "../AdminPage/AdminLayout";
import AdminDashboard from "../AdminPage/AdminDashboard";
import AdminUsers from "../AdminPage/AdminUsers";
import AdminCompanies from "../AdminPage/AdminCompanies";
import AdminProductCategories from "../AdminPage/AdminProductCategories";
import AdminProductTypes from "../AdminPage/AdminProductTypes";
import AdminProducts from "../AdminPage/AdminProducts";
import AdminProductImages from "../AdminPage/AdminProductImages";
import AdminSuppliers from "../AdminPage/AdminSuppliers";
import AdminOrders from "../AdminPage/AdminOrders";
import AdminPosts from "../AdminPage/AdminPosts";
import AdminComments from "../AdminPage/AdminComments";
import AdminNotifications from "../AdminPage/AdminNotifications";
import AdminCompanyRecovery from "../AdminPage/AdminCompanyRecovery";
import BulletinBoard from "../BulletinBoard/BulletinBoard";
import CookiePolicy from "../CookiePolicy/CookiePolicy";
import ForumRules from "../ForumRules/ForumRules";
import Footer from "../Home/Footer";
import Home from "../Home/Home";
import Navbar from "../Navbar/Navbar";
import Philosophy from "../Philosophy/Philosophy";
import PrivacyPolicy from "../Privacy Policy/PrivacyPolicy";
import ProducerProfile from "../ProducerProfile/ProducerProfile";
import Products from "../ProductsPage/Products";
import ProfilePage from "../ProfilePage/ProfilePage";
import ProfileProducerPage from "../ProfilePage/ProfileProducerPage/ProfileProducerPage";

const Layout = () => {
  const [visible, setVisible] = useState(true);
  const [visiblePrivacy, setVisiblePrivacy] = useState(true);
  const { t } = useTranslation("common");
  const location = useLocation();
  // The admin panel is an internal tool for authenticated staff, not a
  // first-time site visitor — the marketing chrome (Navbar/Footer) and the
  // cookie/privacy consent dialogs don't apply to it, and skipping them lets
  // AdminLayout own the full viewport height (no page-level scroll).
  const isAdminRoute = location.pathname.startsWith("/admin");

  const saveConfirm = () => {
    window.localStorage.setItem("userConfirmCookies", "true");
    setVisible(false);
  };

  const saveConfirmPrivacy = () => {
    window.localStorage.setItem("privacy_policy_accepted", "true");
    window.localStorage.setItem("forum_rules_accepted", "true");
    setVisiblePrivacy(false);
  };

  useEffect(() => {
    let vh = window.innerHeight * 0.01;
    document.documentElement.style.setProperty("--vh", `${vh}px`);
  });

  return (
    <div
      className={`flex flex-column div-content-layout ${
        iphone ? "safari" : ""
      } `}
    >
      {!isAdminRoute && <Navbar />}
      <div
        className={`flex flex-column justify-content-between div-routes-layout ${
          iphone ? "safari" : ""
        }`}
      >
        <Routes>
          <Route path="*" element={<NotFound />} />
          <Route path="/" element={<Home />} />
          <Route path="admin" element={<AdminLayout />}>
            <Route index element={<AdminDashboard />} />
            <Route path="users" element={<AdminUsers />} />
            <Route path="companies" element={<AdminCompanies />} />
            <Route path="companyRecovery" element={<AdminCompanyRecovery />} />
            <Route path="categories" element={<AdminProductCategories />} />
            <Route path="product-types" element={<AdminProductTypes />} />
            <Route path="products" element={<AdminProducts />} />
            <Route path="product-images" element={<AdminProductImages />} />
            <Route path="suppliers" element={<AdminSuppliers />} />
            <Route path="orders" element={<AdminOrders />} />
            <Route path="posts" element={<AdminPosts />} />
            <Route path="comments" element={<AdminComments />} />
            <Route path="notifications" element={<AdminNotifications />} />
          </Route>
          <Route path="products" element={<Products />} />
          <Route path="profile" element={<ProfilePage />} />
          <Route path="profile/producer" element={<ProfileProducerPage />} />
          <Route path="philosophy" element={<Philosophy />} />
          <Route path="bulletinboard" element={<BulletinBoard />} />
          <Route path="producerProfile/:id" element={<ProducerProfile />} />
          <Route path="cookiePolicy" element={<CookiePolicy />} />
          <Route path="privacyPolicy" element={<PrivacyPolicy />} />
          <Route path="forumrules" element={<ForumRules />} />
        </Routes>
        {!isAdminRoute && <Footer />}
      </div>
      {isAdminRoute ||
      window.localStorage.getItem("userConfirmCookies") === "true" ? (
        <></>
      ) : (
        <Dialog
          header={t("common:cookieConfirm")}
          visible={visible}
          onHide={saveConfirm}
          style={{ width: "50vw" }}
          position="bottom"
          breakpoints={{ "960px": "75vw", "641px": "100vw" }}
        >
          <div>
            <div style={{ marginBottom: "1rem" }}>
              {t("common:firstSentenceCookieDialog")}
              <Link to={"/cookiePolicy"}>cookie policy</Link>.
              {t("common:secondSentenceCookieDialog")}
            </div>
            <Button className="general-button" onClick={saveConfirm}>
              {t("common:confirm")}
            </Button>
          </div>
        </Dialog>
      )}
      {isAdminRoute ||
      (window.localStorage.getItem("privacy_policy_accepted") === "true" &&
        window.localStorage.getItem("forum_rules_accepted") === "true") ? (
        <></>
      ) : (
        <Dialog
          header={t("common:privacyConfirm")}
          visible={visiblePrivacy}
          onHide={saveConfirmPrivacy}
          style={{ width: "50vw" }}
          position="bottom"
          breakpoints={{ "960px": "75vw", "641px": "100vw" }}
        >
          <div>
            <div style={{ marginBottom: "1rem" }}>
              {t("common:firstSentencePrivacyDialog")}
              <Link to={"/privacyPolicy"}>privacy policy</Link>
              {t("common:secondSentencePrivacyDialog")}
              <Link to={"/forumRules"}>{t("common:forumRules")}</Link>
            </div>
            <Button className="general-button" onClick={saveConfirmPrivacy}>
              {t("common:confirm")}
            </Button>
          </div>
        </Dialog>
      )}
    </div>
  );
};

export default Layout;
